export default __webpack_public_path__ + "images/25c86df17d2758b52d9e35c5ccb4b72e.svg";